import { SelectionPanel } from '$tablet-app/src/app/components/SelectionPanel';
import Text from '$tablet-app/src/app/components/Text';
import { colors } from '@akin-home/theme';
import React from 'react';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';

const BudgetPreferencesView = () => {
  const budget = useMealPreferenceDialogState((state) => state.draft_preferences.budget)
    

  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const onChangeSlider = (budget: number) => update({ budget });

  return (
    <Container>
      <Text weight="semibold">Cost per recipe</Text>

      <CardRow>
        <SelectionPanel
          title="Cheapest"
          subtitle="$8 or less"
          icon="piggy-bank"
          iconColor={colors.green[700]}
          backgroundColor={colors.green.background}
          value={0}
          selected={budget === 0}
          onPress={onChangeSlider}
        />
        <SelectionPanel
          title="Mid-range"
          subtitle="around $15"
          icon="coins"
          iconColor={colors.yellow[700]}
          backgroundColor={colors.yellow.background}
          value={2}
          selected={budget === 2}
          onPress={onChangeSlider}
        />
        <SelectionPanel
          title="Gourmet"
          subtitle="$30 or more"
          icon="money-bills"
          iconColor={colors.blue[700]}
          backgroundColor="rgba(67, 131, 255, 0.15)"
          value={4}
          selected={budget === 4}
          onPress={onChangeSlider}
        />
      </CardRow>
    </Container>
  );
};

const Container = styled.View`
  padding: 30px;
  padding-top: 0;
  gap: 30px;
  align-items: center;
`;

const CardRow = styled.View`
  flex-direction: row;
  gap: 30px;
`;

export default BudgetPreferencesView;
